var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useEffect, useState } from 'react';
import { StatusIndicator } from '@snack-uikit/status';
import { extractSupportProps } from '@snack-uikit/utils';
import { APPEARANCE, SHAPE, SIZE } from './constants';
import styles from './styles.module.css';
import { getAbbreviation } from './utils';
const statusIndicatorSizeMap = {
    [SIZE.Xxs]: 'xxs',
    [SIZE.Xs]: 'xs',
    [SIZE.S]: 'xs',
    [SIZE.M]: 'm',
    [SIZE.L]: 'm',
    [SIZE.Xl]: 'l',
    [SIZE.Xxl]: 'l',
};
/**
 * Компонент отображения аватара пользователя.
 * @constructor
 */
export function Avatar(_a) {
    var { name, appearance = APPEARANCE.Red, size = SIZE.S, shape = SHAPE.Round, indicator, showTwoSymbols, src, className } = _a, rest = __rest(_a, ["name", "appearance", "size", "shape", "indicator", "showTwoSymbols", "src", "className"]);
    const [imageError, setImageError] = useState(false);
    const numberOfSymbols = size !== SIZE.Xxs && showTwoSymbols ? 2 : 1;
    useEffect(() => {
        setImageError(false);
    }, [src]);
    return (_jsxs("div", Object.assign({ className: cn(styles.avatar, className) }, extractSupportProps(rest), { "data-size": size, "data-appearance": appearance, "data-shape": shape, children: [src && !imageError ? (_jsx("img", { "data-test-id": 'image', className: styles.image, src: src, onError: () => setImageError(true), alt: '' })) : (_jsx("div", { "data-test-id": 'abbreviation', children: getAbbreviation(name, numberOfSymbols) })), indicator && (_jsx("div", { className: styles.indicatorWrapper, children: _jsx(StatusIndicator, { "data-test-id": 'indicator', appearance: indicator, size: statusIndicatorSizeMap[size] }) }))] })));
}
